module HeaderService {
    angular.module("AdeMesApp").factory("HeaderService", ["$resource", "ConfigService", ($resource: ng.resource.IResourceService, ConfigService: any) => {
        return {
            logout: $resource(ConfigService.resolveServiceUrl("logout"), {
            }, {
                query: {
                    method: "POST",
                    isArray: false
                }
            }),
            userWorkReport: $resource(ConfigService.resolveServiceUrl("userworkreport"), {
            }, {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "ad_client_id": ConfigService.getAdClientId(),
                        "Accept": "*/*",
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            }),
            getPhaseTypeAlert: $resource(ConfigService.resolveServiceUrl("getphasetypealert"), {
            }, {
                query: {
                    method: "POST",
                    isArray: true,
                    headers: {
                        "ad_client_id": ConfigService.getAdClientId(),
                        "Accept": "*/*",
                        "Content-Type": "application/json; charset=utf-8"
                    }
                }
            })
        }
    }]);
}